// removed by extract-text-webpack-plugin
module.exports = {"item":"src-components-Report-AnswerItem-item-3Y9dm","question":"src-components-Report-AnswerItem-question-2SsWg","answer":"src-components-Report-AnswerItem-answer-1HDZN","button":"src-components-Report-AnswerItem-button-38z16","desc":"src-components-Report-AnswerItem-desc-34exj","bluespan":"src-components-Report-AnswerItem-bluespan-12bGa"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Report/AnswerItem.css
 ** module id = 280
 ** module chunks = 0
 **/